<template>
	<div class="widget-card" :class="{
              'justify-between flex-row-reverse': iconRight,
              'text-center': !iconRight,
            }">
		<feather-icon
			:icon="icon"
			:class="`text-${color}`"
			:style="{background: `rgba(var(--vs-${color}),.15)`}"
			class="p-4 inline-flex widget-card__icon"
		/>
		<div
			:class="{ 'flex flex-row-reverse justify-between items-center flex-grow ml-4': !iconRight }"
			class="truncate"
		>
			<h3 class="widget-card__value">
				<span
					v-if="!delimited"
					:class="{ 'ml-2': !iconRight }"
				>{{ statistic || 0 }}</span>

				<div
					v-else
					:class="{ 'ml-2': !iconRight }"
					class="inline-flex"
				>
					<span class="widget-card__text-green">{{ delimitedStatistic[0] }}</span>
					/
					<span class="widget-card__text-red">{{ delimitedStatistic[1] }}</span>
				</div>
			</h3>
			<span class="widget-card__title">{{ text }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "WidgetCard",
	props: {
		icon: {
			type: String,
			required: false
		},
		color: {
			type: String,
			default: 'disabled'
		},
		text: {
			type: String,
			default: ''
		},
		iconRight: {
			type: Boolean,
			default: false
		},
		statistic: {
			type: [Number, String],
			required: false
		},
		delimited: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		delimitedStatistic() {
			return this.statistic.split("/");
		}
	},
};
</script>

<style lang="scss">
.widget-card {
	display: flex;
	align-items: center;

	&__title {
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__icon {
		border-radius: 12px;

		svg {
			width: 25px;
			height: 25px;
		}
	}

	&__value {
		color: #626262;
		font-size: 22px;
		font-weight: 600;
	}

	.truncate {
		font-size: 14px;
	}

	&__text {
		&-green {
			color: #54AD32;
		}

		&-red {
			color: #DB3B26;
		}
	}
}
</style>
